import { Api } from '@beautybox/core/api';
/** Инициализация модуля запросов */
let provider;
export function init(config) {
    provider = new Api(config.BASE_URL, 'link', config.token, false);
}
import { clearBidsInLocalStorage, checkBidsItem } from '@/utils';

const initialState = () => ({
    appointmentSuccess: false,
    templateBid: { date: '', time: '', servicesIDs: [], employee: {} },
    bids: [
        {
            date: '',
            time: '',
            servicesIDs: [],
            employee: {},
        },
    ],
    bidIndex: 0,
    comment: '',
    loadingBtn: false,
});

const mutations = {
    SET_BIDS(state, bids) {
        console.log('--- SET_BIDS', bids);
        state.bids = bids;
    },
    ADD_BID(state, bid) {
        state.bids.push({ ...bid });
    },
    DELETE_BID(state, index) {
        state.bids.splice(index, 1);
    },

    ADD_COMMENT(state, comment) {
        console.log('--- ADD_COMMENT', comment);
        state.comment = comment;
    },
    CLEAR_EMPLOYEE(state, index = state.bidIndex) {
        state.bids[index].employee = {};
        clearBidsInLocalStorage();
        console.log('--- CLEAR_EMPLOYEE', state.bids[index].employee);
    },
    CLEAR_SERVICE(state, index = state.bidIndex) {
        state.bids[index].servicesIDs = [];
        clearBidsInLocalStorage();
        console.log('--- CLEAR_SERVICE', state.bids[state.bidIndex].servicesIDs);
    },
    CLEAR_ONE_SERVICE(state, { index = state.bidIndex, serviceID }) {
        if (state.bids[index].servicesIDs.includes(serviceID)) {
            const indexToDelete = state.bids[index].servicesIDs.findIndex(
                (item) => item === serviceID
            );
            state.bids[index].servicesIDs.splice(indexToDelete, 1);
            if (state.bids[index].servicesIDs.length === 0) {
                clearBidsInLocalStorage();
            }

            console.log('--- CLEAR_SERVICE', state.bids[state.bidIndex].servicesIDs);
        } else {
            console.log('serviceID not found');
        }
    },
    CLEAR_DATE(state, index = state.bidIndex) {
        console.log('--- CLEAR_DATE');
        state.bids[index].date = '';
        state.bids[index].time = '';
        clearBidsInLocalStorage();
    },
    SELECT_BID_INDEX(state, index) {
        console.log('--- SELECT_BID_INDEX', index);
        state.bidIndex = index;
    },
    SELECT_DATE(state, date) {
        console.log('--- SELECT_DATE', date);
        state.bids[state.bidIndex].date = date;
    },
    SELECT_EMPLOYEE(state, employee) {
        console.log('--- SELECT_EMPLOYEE', employee);
        state.bids[state.bidIndex].employee = employee;
    },
    SELECT_SERVICE(state, id) {
        console.log('--- SELECT_SERVICE', id);
        state.bids[state.bidIndex].servicesIDs = id;
    },
    SELECT_TIME(state, time) {
        console.log('--- SELECT_TIME', time);
        state.bids[state.bidIndex].time = time;
    },
    TOGGLE_APPOINTMENT_SUCCESS(state) {
        console.log('--- TOGGLE_APPOINTMENT_SUCCESS', state.appointmentSuccess);
        state.appointmentSuccess = !state.appointmentSuccess;
        console.log('--- TOGGLE_APPOINTMENT_SUCCESS', state.appointmentSuccess);
    },
    SET_LOADING_BTN(state, value) {
        state.loadingBtn = value;
    },
    CLEAR_ALL_BIDS(state) {
        state.bids = [state.templateBid];
        state.bidIndex = 0;
    },
};

const actions = {
    CLEAR_BID({ commit }) {
        commit('CLEAR_EMPLOYEE');
        commit('CLEAR_SERVICE');
        commit('CLEAR_DATE');
    },
    async ADD_NEW_BID({ commit, state }) {
        try {
            commit('ADD_BID', state.templateBid);
            commit('SELECT_BID_INDEX', state.bids.length - 1);
        } catch (error) {
            console.log(error);
        }
    },
    async REMOVE_BID({ commit, state }, { index }) {
        try {
            commit('DELETE_BID', index);
            const newBidIndex = state.bidIndex >= index ? state.bidIndex - 1 : state.bidIndex;
            commit('SELECT_BID_INDEX', newBidIndex);
        } catch (error) {
            console.log(error);
        }
    },
};

const getters = {
    BIDS: (state) => state.bids,
    BID_INDEX: (state) => state.bidIndex,
    AVERAGE_SUM: (state, getters, rootState, rootGetters) => {
        let sum = 0;

        getters.BIDS.forEach((item) => {
            sum += rootGetters.SERVICES(item.servicesIDs).reduce((acc, item) => {
                return acc + item.price;
            }, 0);
        });

        return sum;
    },
    AVERAGE_PRICE_TYPE: (state, getters, rootState, rootGetters) => {
        if (!getters.BIDS.length <= 1 && !getters.BIDS[0].servicesIDs.length) {
            return 'fixed';
        }
        if (getters.AVERAGE_SUM <= 0) {
            return 'free';
        }
        const hasPriceFrom = getters.BIDS.some((bid) => {
            const services = rootGetters.SERVICES(bid.servicesIDs);
            return services.some((service) => service.priceTypeAlias === 'from');
        });
        if (hasPriceFrom) {
            return 'from';
        }
        return 'fixed';
    },
    CHECK_BIDS: (state) => {
        return state.bids.some((item) => checkBidsItem(item));
    },
    FULL_FILLED_BIDS: (state) => {
        return state.bids.filter((bid) => checkBidsItem(bid));
    },
    COMMENT: (state) => state.comment,
    SELECTED_DATE: (state) => state.bids[state.bidIndex].date,
    SELECTED_TIME: (state) => state.bids[state.bidIndex].time,
    SELECTED_SERVICES: (state) => state.bids[state.bidIndex].servicesIDs,
    SELECTED_EMPLOYEE: (state) => state.bids[state.bidIndex].employee,
    APPOINTMENT_SUCCESS: (state) => state.appointmentSuccess,
};

export default { init, state: initialState, mutations, actions, getters };
